module.exports = __webpack_public_path__ + "static/img/图片21.97067eef.png";